<script setup>
import { shipsTypes2 } from "../staticData"
import { storage } from '../storage'
import ModalBlock from './ModalBlock'
import SpaceBarElement from './SpaceBarElement'
defineEmits(['hide-shop'])

function chooseShip(key) {
    storage.CURRENT_SHIP = key
}
const isDisabled = (key) => {
    if (storage.CURRENT_SHIP === key) return true;
    if (storage.SHIP_OWNED[key] === 0) return true;
    return false;
}
const getShipUrl = (ship) => {
    return '/spacebar-clicker/assets/spacebars/' + shipsTypes2[ship].imgUrl
}
</script>

<template>
   <ModalBlock @closeWindow="$emit('hide-shop')" :height="'fit-content'" :class="'main-block-all'" >
        <template #header>
            <h3>Ships Hangar</h3>
        </template>
        <template #main>
            <div class="column-list">
                <div v-for="(_, ship) in storage.SHIP_OWNED" :key="'galaxy-' + ship" class="item">
                    <img v-if="shipsTypes2[ship].imgUrl" class="ship-type" :src="getShipUrl(ship)" alt="">
                    <SpaceBarElement v-else :classes="'mini'"/>
                    <button class="action-btn" :disabled="isDisabled(ship)" @click="() => chooseShip(ship)">{{ storage.CURRENT_SHIP === ship ? 'Chosen' : 'Choose' }}</button>
                </div>
                <p v-show="Object.keys(storage.SHIP_OWNED).length < Object.keys(shipsTypes2).length" class="comment">Unlock other Ships by pressing SpaceBar</p>
            </div>
        </template>
    </ModalBlock>
</template>

<style scoped>
.column-list .item {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 5px;
    margin: 5px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.699);
    /* min-width: 250px; */
}

.item p {
    margin: 0 5px;
}

.ship-type {
    max-width: 200px;
    max-height: 60px;
    height: auto;
}

.comment {
    margin: 5px;
    text-align: center;
    font-size: 1.1rem;
}
</style>